import { render, staticRenderFns } from "./TeamTwo.vue?vue&type=template&id=45b4cee5&"
import script from "./TeamTwo.vue?vue&type=script&lang=js&"
export * from "./TeamTwo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports